<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {}
}
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: absolute;
  height: 100%;
  width: 100%;
  color: var(--im-text-color);
  font-family: var(--im-font-family);
}

/* ===== 移动端响应式适配 ===== */
@media screen and (max-width: 768px) {
  .home-page .app-container {
    width: 100vw !important;
    height: 100vh !important;
    min-width: 0 !important;
    min-height: 0 !important;
    border-radius: 0 !important;
  }
  .chat-page > .resizable-aside {
    width: 100% !important;
    flex: 1 !important;
  }
  .chat-page > .chat-main {
    display: none !important;
  }
  .chat-page.mobile-chat-open > .resizable-aside {
    display: none !important;
  }
  .chat-page.mobile-chat-open > .chat-main {
    display: flex !important;
  }
  .home-page .content-box,
  .chat-page,
  .chat-page > .chat-main,
  .chat-box,
  .chat-box > .el-container,
  .chat-box .el-main,
  .chat-box .el-footer,
  .chat-box .im-chat-main {
    min-width: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
    overflow-x: hidden !important;
  }
  .chat-tool-bar {
    flex-wrap: wrap;
  }
  .mobile-back-btn {
    display: inline-block !important;
    margin-right: 8px;
    font-size: 20px;
    cursor: pointer;
  }
}
.mobile-back-btn {
  display: none;
}
</style>
